// Zoom Groom's salons are in America/Chicago. Date-only values from
// <input type="date"> are calendar days, not instants. `new Date('YYYY-MM-DD')`
// parses them as UTC midnight, which is the previous evening in Chicago.

export const SALON_TIME_ZONE = 'America/Chicago';

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function salonDateISO(date = new Date()) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: SALON_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}

export function addSalonDays(isoDate, days) {
    const match = String(isoDate || '').trim().match(DATE_ONLY);
    if (!match) return '';
    const utcNoon = new Date(Date.UTC(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]) + days,
        12
    ));
    return utcNoon.toISOString().slice(0, 10);
}

export function formatSalonDate(value, options = {}) {
    if (value === undefined || value === null || value === '') return '';
    const text = String(value).trim();
    const dateOnly = text.match(DATE_ONLY);
    if (dateOnly) {
        const utcNoon = new Date(Date.UTC(
            Number(dateOnly[1]),
            Number(dateOnly[2]) - 1,
            Number(dateOnly[3]),
            12
        ));
        return new Intl.DateTimeFormat('en-US', { ...options, timeZone: 'UTC' }).format(utcNoon);
    }

    const parsed = new Date(text);
    if (Number.isNaN(parsed.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', { ...options, timeZone: SALON_TIME_ZONE }).format(parsed);
}
